import { updateLinksAttributes } from '../../utils/handleAttributes';
import { missingWidget } from '../../utils/helpers';

export default function customSignup() {
  const $emailSignup = $('.content .emailSignup');
  const widgetName = 'customSignup';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof customSignupOpts === 'undefined' ? null : customSignupOpts;

  if (!widgetOpts) {
    $widget.remove();
    $emailSignup.remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      $widget.replaceWith($emailSignup);

      if (hasData) {
        createCustomSignUp(data.items);
      } else {
        $widget.remove();
        $emailSignup.remove();
      }
    },
  });

  function createCustomSignUp(widgetData) {
    updateSignupFeature(widgetData, widgetName);
  }
}

function updateSignupFeature(data, idName) {
  const { Title, Description, URL } = data[0];
  const containerSectionClass = 'customSeoBlock-signup-container';

  const signupTitle = Title;
  const signupText = Description;
  const inputPlaceholder = 'Email Address';
  const buttonLabel = 'Subscribe';

  const $signupElement = $(`.${containerSectionClass} .emailSignup`);
  const $signupText = $signupElement.find('.emailSignupText');

  $signupText.replaceWith(`
    <div class="signup-text">
      <h2 class="signup-title">${signupTitle}</h2>
      ${signupText == '' ? `` : `<p class="signup-description">${signupText}</p>`}
    </div>
    `);

  $signupElement.attr('id', idName);
  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-container"></div>');
  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);
  $signupElement.find('.emailInputSubmit a').text(buttonLabel).addClass('alternative-btn');

  if (URL) {
    $signupElement.find('.input-container').addClass('custom-signup').empty().append(`
      <a href="${URL}" class="button alternative-btn"  ${updateLinksAttributes(URL, signupTitle)}>${buttonLabel}</a>`);
  }
}
